/* eslint-disable react/no-unused-prop-types */

/* eslint-disable no-else-return */
/* eslint-disable react/prop-types */

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable prefer-destructuring */

/* eslint-disable no-shadow */

import React, { useEffect, useState, useRef, createRef } from "react";
import { Icon, Table, Header, Pagination, Button, Popup, List, Checkbox /* , Modal  */, Menu } from "semantic-ui-react";
import { isEmpty, slice, map, orderBy, takeRight, filter, escapeRegExp, includes, without, find, reject, get, isEqual } from "lodash";
import { useReactToPrint } from "react-to-print";
// import ReactExport from "react-export-excel";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";

// Styles
import styles from "./styles.module.css";

// components
import Text from "../Text";
/* import Input from "../../components/Input"; */
import Input from "../Input";
import NewTablePrint from "../NewTablePrint";

// Utils
import { getTimeLabel, dropdownFormat, timeBetweenDatesCurrent, pastDays, phoneFormat, currencyFormat } from "./utils";

// formats

const NewTable = (props) => {
	const {
		columns,
		defaultOrder,
		pageRows,
		data,
		searchable,
		searchPosition,
		searchDisable = false,
		searchDropdownPosition = "right",
		handlerTable,
		onMultipleChange,
		multipleSelected,
		multiplePosition,
		printable,
		printHeader,
		onChangeReset,
		addButton,
		topCustomButtons,
		bottomCustomButtons,
		keyField,
		onInputChange,
		getTableData,
		columnSum,
		negativeRows,
		hiddenTopCustomButtons = true,
		widthZero = false,
		haveFooter = true,
		haveRadio = false,
		radioReset,
		rowStyle = () => {},
		mobileCardView = false,
		mobileCardData,
		cardLine1 = [],
		cardLine2 = [],
		cardLine3 = [],
		showRowSelector = false,
		mobileAddButton = false,
	} = props;
	const componentRef = useRef();

	// hooks
	const [headerRefs, setHeaderRefs] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [activePage, setActivePage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [sortDirection, setSortDirection] = useState("");
	const [sortedColumnKey, setSortedColumnKey] = useState("");
	const [searchQuery, setSearchQuery] = useState("");
	const [searchOptions, setSearchOptions] = useState([]);
	const [searchField, setSearchField] = useState("all");
	const [clikedData, setClikedData] = useState({});
	const [radioClikedData, setRadioClikedData] = useState({});
	const [concatValue, setConcatValue] = useState([]);
	const [formatExelData, setFormatExelData] = useState([]);
	const [columnsExel, setColumnsExel] = useState([]);
	const [hiddenColumns, setHiddenColumns] = useState([]);
	const [openHeaderOptions, setOpenHeaderOptions] = useState([]);
	const [searchedData, setSearchedData] = useState([]);
	const [printData, setPrintData] = useState([]);
	const [dataField, setDataField] = useState([]);
	const [reset2, setReset2] = useState(0);
	// const ExcelFile = ReactExport.ExcelFile;
	// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
	// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
	// Effects
	useEffect(() => {
		if (data) {
			let searchData = [];
			const searchableKeys = GroupSearchableKeys(columns);
			const searchableItems = groupSearchableItems(columns);
			if (searchField === "all") {
				searchData = searchOnData(searchQuery, dataField, searchableKeys);
			} else {
				searchData = searchOnData(searchQuery, dataField, [searchField]);
			}
			const sortedData = SortData(defaultOrder, searchData);
			const searchableOptions = dropdownFormat(searchableItems, "label", "key");
			const pageData = slice(sortedData, 0, pageRows);
			if (dataField.length !== searchData.length) {
				setTotalPages(Math.ceil(searchData.length / pageRows));
			} else {
				setTotalPages(Math.ceil(dataField.length / pageRows));
			}
			setSearchedData(searchData);
			setPrintData(searchData);
			setFilteredData(pageData);
			setSearchOptions([{ key: 0, text: "Todos", value: "all" }, ...searchableOptions]);

			setClikedData({});
			setActivePage(1);
			if (defaultOrder) {
				const sortDir = defaultOrder.dir === "asc" ? "ascending" : "descending";
				setSortDirection(sortDir);
				setSortedColumnKey(defaultOrder.key);
			}
		}
	}, [searchQuery, searchField, reset2]);

	useEffect(() => {
		const searchableItems = groupSearchableItems(columns);
		const searchableOptions = dropdownFormat(searchableItems, "label", "key");
		if (data) {
			exelData();
			const headerRef = map(columns, () => {
				return createRef();
			});
			let dataFields = [];
			if (keyField) {
				dataFields = map(data, (item) => {
					const newItem = { ...item, fieldId: item[keyField] };
					return newItem;
				});
			} else {
				dataFields = data;
			}
			const openHeaderOption = map(columns, () => {
				return false;
			});
			const searchableKeys = GroupSearchableKeys(columns);

			let searchData = [];
			if (searchField === "all") {
				searchData = searchOnData(searchQuery, dataFields, searchableKeys);
			} else {
				searchData = searchOnData(searchQuery, dataFields, [searchField]);
			}

			const offset = (activePage - 1) * pageRows;
			let sortedData = [];
			/* f (isEmpty(sortedColumnKey) && isEmpty(sortDirection)) { */
			sortedData = SortData(defaultOrder, searchData);
			/* } else {
				sortedData = SortData(null, searchData, false, sortedColumnKey, sortDirection);
			} */

			const filteredItems = slice(sortedData, offset, offset + pageRows);
			setSearchedData(searchData);
			setPrintData(searchData);
			setFilteredData(filteredItems);
			setDataField(dataFields);

			if (dataField.length !== searchData.length) {
				setTotalPages(Math.ceil(searchData.length / pageRows));
			} else {
				setTotalPages(Math.ceil(dataField.length / pageRows));
			}
			setHeaderRefs(headerRef);
			setOpenHeaderOptions(openHeaderOption);
		}
		if (defaultOrder) {
			const sortDir = defaultOrder.dir === "asc" ? "ascending" : "descending";
			setSortDirection(sortDir);
			setSortedColumnKey(defaultOrder.key);
		}

		setSearchOptions([{ key: 0, text: "Todos", value: "all" }, ...searchableOptions]);
	}, [data]);

	useEffect(() => {
		if (onChangeReset) {
			setSearchQuery("");
			setSearchField("all");
			setReset2(reset2 + 1);
			setConcatValue([]);
		}
	}, [onChangeReset]);

	useEffect(() => {
		if (data) exelData();
	}, [hiddenColumns]);

	useEffect(() => {
		if (multipleSelected) {
			let newSelected = [];
			if (keyField) {
				newSelected = map(multipleSelected, (item) => {
					const newItem = { ...item, fieldId: item[keyField] };
					return newItem;
				});
			} else {
				newSelected = multipleSelected;
			}
			setConcatValue(newSelected);
		}
	}, [multipleSelected]);

	useEffect(() => {
		if (haveRadio) {
			const radioColumn = find(columns, { radio: true });
			const radioKey = get(radioColumn, "key", false);
			if (radioKey) {
				const rowData = find(data, { [radioKey]: true });
				setRadioClikedData(rowData);
			}
		}
	}, [radioReset]);

	/* setRadioClikedData; */

	const fieldEqual = (A, B) => {
		const fieldIdArrayA = map(A, (item) => {
			return item.fieldId;
		});

		const fieldIdArrayB = map(B, (item) => {
			return item.fieldId;
		});

		return isEqual(fieldIdArrayA.sort(), fieldIdArrayB.sort());
	};

	const GroupSearchableKeys = (columns) => {
		let searchableKeys = [];
		for (const column of columns) {
			if (!column.hidden && !column.action && !column.multiple) {
				if (column.twoLines) {
					if (get(column.line1, "canFilter", true) /* column.line1.canFilter */) {
						searchableKeys = [...searchableKeys, column.line1.key];
					}
					if (get(column.line2, "canFilter", true) /* column.line2.canFilter */) {
						searchableKeys = [...searchableKeys, column.line2.key];
					}
				} else if (get(column, "canFilter", true) /* column.canFilter */) {
					searchableKeys = [...searchableKeys, column.key];
				}
			}
		}
		return searchableKeys;
	};

	const groupSearchableItems = () => {
		let items = [];
		for (const column of columns) {
			if (!column.hidden && !column.action && !column.multiple) {
				if (column.twoLines) {
					if (get(column.line1, "canFilter", true)) {
						items = [...items, column.line1];
					}
					if (get(column.line2, "canFilter", true)) {
						items = [...items, column.line2];
					}
				} else if (get(column, "canFilter", true)) {
					items = [...items, column];
				}
			}
		}
		return items;
	};

	const truncateString = (str, num) => {
		const icon = (
			<span className={styles.icon}>
				<Popup
					position="bottom right"
					content={str}
					/* header={"Texto Completo"} */ trigger={<Icon name="comment alternate outline" style={{ color: "#286b92" }} />}
				/>
			</span>
		);
		if (num >= str.length) {
			return str;
		}
		str = str.substring(0, num);
		return [`${str}...`, icon];
	};
	const truncateArray = (str, num, objectArray) => {
		let content;
		if (objectArray) {
			content = str;
		} else {
			content = map(str, (item, keyValueIndex) => {
				return (
					<div className={styles.arrayCell} key={keyValueIndex}>
						{item}
					</div>
				);
			});
		}

		const icon = (
			<span className={styles.icon}>
				<Popup position="bottom right" content={content} trigger={<Icon name="comment alternate outline" style={{ color: "#286b92" }} />} />
			</span>
		);

		if (num >= str.length) {
			return str;
		}
		if (objectArray) {
			str = str[0].props?.children[0];
			return [`${str}...`, icon];
		}
		str = str[0];
		return [`${str}...`, icon];
	};

	const handleInput = (event) => {
		setSearchQuery(event.target.value);
	};

	const handleDropdown = (e, { value }) => {
		setSearchField(value);
	};

	const matchString = (data, value) => {
		const regExp = new RegExp(escapeRegExp(value), "i");

		return regExp.test(data);
	};

	function removeAccents(cadena) {
		const acentos = {
			á: "a",
			é: "e",
			í: "i",
			ó: "o",
			ú: "u",
			Á: "A",
			É: "E",
			Í: "I",
			Ó: "O",
			Ú: "U",
		};
		return cadena
			.split("")
			.map((letra) => {
				return acentos[letra] || letra;
			})
			.join("")
			.toString();
	}

	const searchOnData = (querys, data, keys) => {
		const query = removeAccents(querys);
		if (isEmpty(query)) return data;
		if (isEmpty(data)) return data;
		if (isEmpty(keys)) return data;
		let filteredData = data;
		filteredData = filter(data, (item) => {
			for (const key of keys) {
				const arrayOptions = key.split(",");
				if (arrayOptions.length === 1) {
					const keyOptions = arrayOptions[0].split(".");
					const remainingKeys = takeRight(keyOptions, keyOptions.length - 1);
					let info = getKeyValue(item, keyOptions[0], remainingKeys);

					if (info) {
						info = removeAccents(info.toString());
					}
					if (matchString(keyOptions, "Date")) {
						if (matchString(getTimeLabel(info, false, false, true), query)) return true;
					} else if (matchString(keyOptions, "orderType")) {
						if (matchString("Pedido", query) && matchString(info, "order")) return true;
						if (matchString("Tarea", query) && matchString(info, "task")) return true;
					} else if (matchString(info, query)) return true;
				} else {
					for (const arrayItem of item[arrayOptions[0]]) {
						const keyOptions = arrayOptions[1].split(".");
						const remainingKeys = takeRight(keyOptions, keyOptions.length - 1);
						const info = getKeyValue(arrayItem, keyOptions[0], remainingKeys);
						if (matchString(keyOptions, "Date")) {
							if (matchString(getTimeLabel(info, false, false, true), query)) return true;
						} else if (matchString(keyOptions, "orderType")) {
							if (matchString("Pedido", query) && matchString(info, "order")) return true;
							if (matchString("Tarea", query) && matchString(info, "task")) return true;
						} else if (matchString(info, query)) return true;
					}
				}
			}
			return false;
		});

		return filteredData;
	};

	const handleSort = (key) => {
		const direction = sortDirection === "descending" ? "ascending" : "descending";
		let sortedData = [];
		if (searchQuery) {
			sortedData = SortData(null, searchedData, false, key, direction);
		} else {
			sortedData = SortData(null, dataField, false, key, direction);
		}
		setPrintData(sortedData);
		setTotalPages(Math.ceil(sortedData.length / pageRows));
		setFilteredData(slice(sortedData, 0, pageRows));
		setSortDirection(direction);
		setSortedColumnKey(key);
		setActivePage(1);
	};

	const SortData = (defaultOrder, data, IsDefauldOrder = true, key, dir) => {
		let sortedItems = data;
		if (IsDefauldOrder === true) {
			let sortDir = "ascending";
			if (defaultOrder) {
				if (defaultOrder.dir) {
					sortDir = defaultOrder.dir === "asc" ? "ascending" : "descending";
				}
				if (defaultOrder.key) {
					const orderDirection = sortDir === "descending" ? "desc" : "asc";
					sortedItems = orderBy(data, defaultOrder.key, orderDirection);
				}
			}
		} else if (key) {
			const orderDirection = dir === "descending" ? "desc" : "asc";
			sortedItems = orderBy(data, key, orderDirection);
		}
		if (getTableData) getTableData(sortedItems);
		return sortedItems;
	};

	const getKeyValue = (object, currentKey, keyArray) => {
		if (isEmpty(keyArray)) {
			return object[currentKey];
		}
		if (object[currentKey]) {
			const newKeyArray = takeRight(keyArray, keyArray.length - 1);
			return getKeyValue(object[currentKey], keyArray[0], newKeyArray);
		}
		return "";
	};

	const onPageChanged = (e, pageData) => {
		e.preventDefault();
		const { activePage } = pageData;
		const offset = (activePage - 1) * pageRows;
		let sortedData = [];
		if (isEmpty(sortedColumnKey) && isEmpty(sortDirection)) {
			sortedData = SortData(defaultOrder, searchedData);
		} else {
			sortedData = SortData(null, searchedData, false, sortedColumnKey, sortDirection);
		}

		const filteredItems = slice(sortedData, offset, offset + pageRows);
		setActivePage(activePage);
		setFilteredData(filteredItems);
	};

	const renderItemCount = (itemRange, currentItems, totalItems) => {
		if (totalItems <= 1) {
			return <span className={styles.itemCount}>Elementos: 1-1 / {totalItems}</span>;
		}
		const beginRow = itemRange + 1;
		let finalRow = itemRange + currentItems;
		const totalPagesCalc = Math.ceil(totalItems / pageRows);
		if (activePage === totalPagesCalc) {
			finalRow = totalItems;
		}
		return <span className={styles.itemCount}>{`Elementos: ${beginRow}-${finalRow}/ ${totalItems}`}</span>;
	};

	const renderColorLabel = (value, colorLabel, onClick, labelData, translate) => {
		let color = "#2483bb";
		if (colorLabel) {
			const colorkeyObjet = colorLabel[0];
			if (colorkeyObjet) {
				if (colorkeyObjet.colorKey) {
					if (labelData) {
						color = getData(colorkeyObjet.colorKey, labelData);
					}
				} else {
					for (const label of colorLabel) {
						if (label.onName === value) {
							color = label.color;
						} else if (label.default) {
							color = label.default;
						}
					}
				}
			}
		}
		if (onClick) {
			return (
				<Button
					style={{ backgroundColor: color }}
					className={styles.ButtonLabel}
					onClick={() => {
						return typeof onClick === "function" ? onClick(labelData) : onHandlerTable(onClick, labelData);
					}}
					fluid>
					{!isEmpty(translate) ? renderTranslate(value, translate) : String(value)}
				</Button>
			);
		}
		if (!value) {
			return null;
		}
		return (
			<Button style={{ backgroundColor: color }} className={styles.ButtonLabel} fluid>
				{!isEmpty(translate) ? renderTranslate(value, translate) : String(value)}
			</Button>
		);
	};

	const renderTranslate = (value, translate) => {
		let newValue = value;
		if (translate) {
			for (const item of translate) {
				if (item.onName === value) {
					newValue = String(item.translate);
				}
			}
		}

		return newValue;
	};

	const timeBetweenDates = (value, endDate, onKeyEndDate, rowData) => {
		let enDate = endDate;
		if (onKeyEndDate) {
			const onKeyEndDateValue = getData(onKeyEndDate, rowData);
			for (const item of endDate) {
				if (item.onName === onKeyEndDateValue) {
					if (boolConverter(item.endDate)) {
						enDate = getData(item.endDate, rowData);
						break;
					} else {
						enDate = null;
					}
				} else {
					enDate = null;
				}
			}
		}
		return timeBetweenDatesCurrent(value, enDate);
	};

	const formatData = (
		format,
		value,
		endDate,
		boolLabels,
		colorLabel,
		translate,
		onClick,
		labelData,
		onKeyEndDate,
		stringLength,
		disabled
	) => {
		switch (format) {
			case "timeBetween":
				return timeBetweenDates(value, endDate, onKeyEndDate, labelData);

			case "date":
				return getTimeLabel(value, false, false, false);

			case "time":
				return getTimeLabel(value, false, true, false);

			case "dateTime":
				return getTimeLabel(value, false, false, true);

			case "dateTimeDay":
				return getTimeLabel(value, false, false, false, true);

			case "pastDays":
				return pastDays(value);

			case "phone":
				return phoneFormat(value);

			case "currency":
				return currencyFormat(value, false, widthZero);

			case "integerCurrency":
				return currencyFormat(value, true, widthZero);

			case "blankZero":
				return value === 0 ? "" : value;

			case "count":
				if (value) {
					return value.length;
				}
				return 0;

			case "boolean":
				if (boolLabels) {
					if (value) {
						return boolLabels.true;
					}
					return boolLabels.false;
				}
				if (value) {
					return "si";
				}
				return "no";

			case "label":
				return renderColorLabel(value, colorLabel, onClick, labelData, translate);

			case "translate":
				return renderTranslate(value, translate);

			case "input":
				return (
					<Input
						className={styles.inputNumber}
						type="number"
						value={value.toString()}
						onChange={(e) => {
							return handleInputNumber(e, labelData, onKeyEndDate);
						}}
						onKeyPress={(e) => {
							return e.key === "Enter" && e.preventDefault();
						}}
						disabled={disabled}
					/>
				);
			case "inputHour":
				return (
					<div>
						<Input
							className={styles.inputTime}
							type="time"
							value={value}
							onChange={(e) => {
								return onInputChange(e.target.value, labelData, onKeyEndDate);
							}}
							onKeyPress={(e) => {
								return e.key === "Enter" && e.preventDefault();
							}}
							disabled={disabled}
						/>
					</div>
				);
			case "truncate":
				return truncateString(value, stringLength, labelData);

			default:
				return value;
		}
	};

	const formatPrintData = (format, value, labelData, endDate, onKeyEndDate, translate, boolLabels) => {
		switch (format) {
			case "timeBetween":
				return timeBetweenDates(value, endDate, onKeyEndDate, labelData);

			case "date":
				return getTimeLabel(value, false, false, false);

			case "time":
				return getTimeLabel(value, false, true, false);

			case "dateTime":
				return getTimeLabel(value, false, false, true);

			case "count":
				if (value) {
					return value.length;
				}
				return 0;

			case "boolean":
				if (boolLabels) {
					if (value) {
						return boolLabels.true;
					}
					return boolLabels.false;
				}
				if (value) {
					return "si";
				}
				return "no";

			case "translate":
				return renderTranslate(value, translate);

			default:
				return value;
		}
	};

	const handleInputNumber = (event, item, onKeyEndDay) => {
		onInputChange(event.target.value, item, onKeyEndDay);
		// if (/[0-9]/.test(event.target.value)) {
		// onInputChange(parseInt(event.target.value, 10), item, onKeyEndDay);
		// } else {
		// 	event.preventDefault();
		// }
	};

	const formatAction = (rowItem, rowData, index) => {
		const renderOption = map(rowItem.action, (options, optionsIndex) => {
			let isVisible = false;
			if (options.isVisible) {
				isVisible = options.isVisible(rowData);
			}
			switch (options.type) {
				case "icon":
					if (!options.hidden && !isVisible) {
						return (
							<Button
								key={index + optionsIndex}
								className={styles.ButtonIcon}
								style={{ color: options.color, border: `2px solid ${options.color}` }}
								onClick={() => {
									return onHandlerTable(options.onClick, rowData);
								}}>
								<Icon name={options.content} />
							</Button>
						);
					}
					return null;

				case "link":
					if (!options.hidden) {
						return (
							<div
								key={index + optionsIndex}
								style={{ color: options.color }}
								className={styles.ButtonLink}
								onClick={() => {
									return onHandlerTable(options.onClick, rowData);
								}}>
								{options.content}
							</div>
						);
					}
					return null;

				case "label":
					if (rowItem.key) {
						const { key } = rowItem;
						const { format } = rowItem;
						const keyValue = getData(key, rowData);
						const { endDate } = rowItem;
						const { boolLabels } = rowItem;
						let endDateValue = null;
						if (endDate) {
							endDateValue = getData(endDate, rowData);
						}
						return (
							<Button
								key={index + optionsIndex}
								className={styles.ButtonLabel}
								style={{ backgroundColor: options.color }}
								fluid
								onClick={() => {
									return onHandlerTable(options.onClick, rowData);
								}}>
								{formatData(format, keyValue, endDateValue, boolLabels)}
							</Button>
						);
					}
					return (
						<Button
							key={index + optionsIndex}
							className={styles.ButtonLabel}
							style={{ backgroundColor: options.color }}
							fluid
							onClick={() => {
								return onHandlerTable(options.onClick, rowData);
							}}>
							{String(options.content)}
						</Button>
					);

				default:
					break;
			}
		});
		return renderOption;
	};

	const onHandlerTable = (name, item) => {
		if (handlerTable) {
			handlerTable(name, item);
		}

		/*  setClikedData(item) */
	};

	const checkBoxValue = () => {
		if (fieldEqual(concatValue, searchedData)) {
			setConcatValue([]);
			if (onMultipleChange) onMultipleChange([]);
		} else {
			setConcatValue(searchedData);
			if (onMultipleChange) onMultipleChange(searchedData);
		}
	};

	const TableValue = (item) => {
		if (keyField) {
			const concatField = find(concatValue, { fieldId: item.fieldId });
			if (concatField?.fieldId !== item.fieldId) {
				if (isEmpty(concatValue)) {
					setConcatValue([item]);
					if (onMultipleChange) onMultipleChange([item]);
				} else {
					setConcatValue([...concatValue, item]);
					if (onMultipleChange) onMultipleChange([...concatValue, item]);
				}
			} else {
				const valueContactDel = reject(concatValue, { fieldId: item.fieldId });
				setConcatValue(valueContactDel);
				if (onMultipleChange) onMultipleChange(valueContactDel);
			}
		} else if (!includes(concatValue, item)) {
			if (isEmpty(concatValue)) {
				setConcatValue([item]);
				if (onMultipleChange) onMultipleChange([item]);
			} else {
				setConcatValue([...concatValue, item]);
				if (onMultipleChange) onMultipleChange([...concatValue, item]);
			}
		} else {
			const valueContactDel = without(concatValue, item);
			setConcatValue(valueContactDel);
			if (onMultipleChange) onMultipleChange(valueContactDel);
		}

		/*  if (onMultipleChange) {
			onMultipleChange(concatValue);
		} */
	};

	const getData = (key, rowData) => {
		if (key) {
			const keyOptions = key.split(".");
			const remainingKeys = takeRight(keyOptions, keyOptions.length - 1);
			return getKeyValue(rowData, keyOptions[0], remainingKeys);
		}
		return null;
	};

	const boolConverter = (item) => {
		let keyValue = item;
		if (typeof keyValue === "object") {
			if (isEmpty(keyValue)) {
				keyValue = false;
			} else {
				keyValue = true;
			}
		} else if (keyValue) {
			keyValue = true;
		} else {
			keyValue = false;
		}
		return keyValue;
	};

	const renderIcon = (iconInfo, rowData) => {
		const icons = map(iconInfo, (iconData, index) => {
			if (iconData.renderKey) {
				let keyValue = true;
				let keyValue2 = false;
				if (typeof iconData.renderKey === "object") {
					keyValue = boolConverter(getData(iconData.renderKey[0], rowData));
					keyValue2 = boolConverter(getData(iconData.renderKey[1], rowData));
				} else {
					keyValue = boolConverter(getData(iconData.renderKey, rowData));
				}
				if (iconData.type === "popUp") {
					let popUpContent = "";
					if (iconData.popUpType === "list") {
						const key = iconData.popUpKey;
						const keyArray = key.split(",");
						const arrayData = getData(keyArray[0], rowData);
						let commentKeyValue = null;
						if (iconData.popUpCommentKey) {
							commentKeyValue = getData(iconData.popUpCommentKey, rowData);
							if (boolConverter(commentKeyValue)) {
								commentKeyValue = (
									<div key={index} className={styles.popUpContent}>
										{commentKeyValue}
									</div>
								);
							} else {
								commentKeyValue = null;
							}
						}
						if (keyValue === iconData.onBool || keyValue2 === iconData.onBool) {
							const list = map(arrayData, (listData, listDataIndex) => {
								if (typeof listData !== "object") {
									return (
										<List.Item key={index + listDataIndex} as="li">
											{listData}
										</List.Item>
									);
								}
								return (
									<List.Item key={index + listDataIndex} as="li">
										{getData(keyArray[1], listData)}
									</List.Item>
								);
							});

							popUpContent = <List as="ol">{[commentKeyValue, ...list]}</List>;
							return (
								<span key={index} className={styles.icon}>
									<Popup
										position="bottom center"
										content={popUpContent}
										key={index}
										header={iconData.popUpTitle}
										trigger={<Icon name={iconData.content} style={{ color: iconData.color }} />}
									/>
								</span>
							);
						}
					} else {
						popUpContent = getData(iconData.popUpKey, rowData);
						if (keyValue === iconData.onBool) {
							return (
								<span key={index} className={styles.icon}>
									<Popup
										content={popUpContent}
										header={iconData.popUpTitle}
										trigger={<Icon name={iconData.content} style={{ color: iconData.color }} />}
									/>
								</span>
							);
						}
					}
				} else if (keyValue === iconData.onBool) {
					return (
						<span key={index} className={styles.icon}>
							<Icon name={iconData.content} style={{ color: iconData.color }} />
						</span>
					);
				}
			} else {
				if (iconData.type === "popUp") {
					let popUpContent = "";
					if (iconData.popUpType === "list") {
						const key = iconData.popUpKey;
						const keyArray = key.split(",");
						const arrayData = getData(keyArray[0], rowData);
						const list = map(arrayData, (listData, indexlist) => {
							return (
								<List.Item key={index + indexlist} as="li">
									{getData(keyArray[1], listData)}
								</List.Item>
							);
						});
						popUpContent = <List as="ol">{list}</List>;
						return (
							<span key={index} className={styles.icon}>
								<Popup
									content={popUpContent}
									key={index}
									header={iconData.popUpTitle}
									trigger={<Icon name={iconData.content} style={{ color: iconData.color }} />}
								/>
							</span>
						);
					}
					popUpContent = getData(iconData.popUpKey, rowData);
					return (
						<span key={index} className={styles.icon}>
							<Popup
								content={popUpContent}
								key={index}
								header={iconData.popUpTitle}
								trigger={<Icon name={iconData.content} style={{ color: iconData.color }} />}
							/>
						</span>
					);
				}
				return (
					<span key={index} className={styles.icon}>
						<Icon name={iconData.content} style={{ color: iconData.color }} />
					</span>
				);
			}
		});
		return icons;
	};

	const handlerClick = (rowData, multiple) => {
		if (multiple) {
			TableValue(rowData);
			/*  onHandlerTable("onClick", rowData); */
		} else {
			onHandlerTable("onClick", rowData);
			setClikedData(rowData);
		}
	};

	const handlerRatio = (rowData, disabled) => {
		if (!disabled) {
			if (radioClikedData !== rowData) {
				onHandlerTable("Ratio", rowData);
				setRadioClikedData(rowData);
			} else {
				onHandlerTable("Ratio", {});
				setRadioClikedData({});
			}
		}
	};

	const handleCloseHeaderOptions = () => {
		const openHeaderOption = map(openHeaderOptions, () => {
			return false;
		});
		setOpenHeaderOptions(openHeaderOption);
	};

	const handleContextMenu = (e, index) => {
		e.preventDefault();
		const openHeaderOption = map(openHeaderOptions, (item, itemIndex) => {
			if (itemIndex === index) return true;
			return false;
		});
		setOpenHeaderOptions(openHeaderOption);
	};

	const hideData = (e, item, string) => {
		e.preventDefault();
		const openHeaderOption = map(openHeaderOptions, () => {
			return false;
		});

		if (string === "inactive") {
			const dataValue = without(hiddenColumns, item);
			setHiddenColumns(dataValue);
			setOpenHeaderOptions(openHeaderOption);
		} else {
			const dataValue = [...hiddenColumns, item];
			setHiddenColumns(dataValue);
			setOpenHeaderOptions(openHeaderOption);
		}
	};

	const headerPrint = () => {
		return (
			<Table.Header className={styles.headerTable}>
				<Table.Row>
					{columns.map((item, index) => {
						if (!item.hidden) {
							if (!includes(hiddenColumns, item)) {
								if (get(item, "canPrint", true)) {
									const sorted = false;

									if (item.multiple) {
										return null;
									}
									if (item.action) {
										return null;
									}
									if (item.twoLines) {
										return (
											<Table.HeaderCell
												key={index}
												className={styles.tableCellHeader}
												textAlign={item.headerPosition || "center"}
												width={item.width || 1}
												sorted={sorted ? sortDirection : null}>
												<div>{item.line1.label}</div>
												<div> {item.line2.label} </div>
											</Table.HeaderCell>
										);
									}
									return (
										<Table.HeaderCell
											key={index}
											className={styles.tableCellHeader}
											textAlign={item.headerPosition || "center"}
											width={item.width || 1}
											sorted={sorted ? sortDirection : null}>
											{item.label}
										</Table.HeaderCell>
									);
								}
								return null;
							}
							return null;
						}
						return null;
					})}
				</Table.Row>
			</Table.Header>
		);
	};

	const tableRowPrint = () => {
		const data = printData; /* filteredData */
		const rowTable = map(data, (rowData, index) => {
			const negative = rowData.isActive === false;

			return (
				<Table.Row
					negative={negative}
					key={index}
					className={styles.groupHover}
					onDoubleClick={() => {
						onHandlerTable("Watch", rowData);
					}}>
					{map(columns, (rowItem, rowItemIndex) => {
						if (!rowItem.hidden) {
							if (!includes(hiddenColumns, rowItem)) {
								if (rowItem.action) {
									return null;
								}
								if (rowItem.multiple) {
									return null;
								}
								if (rowItem.twoLines) {
									/* imprimir */
									const key1 = rowItem.line1.key;
									const key2 = rowItem.line2.key;
									const format1 = rowItem.line1.format;
									const format2 = rowItem.line2.format;
									const keyValue1 = getData(key1, rowData);
									const keyValue2 = getData(key2, rowData);
									const endDate1 = rowItem.line1.endDate;
									const endDate2 = rowItem.line2.endDate;
									const boolLabels1 = rowItem.line1.boolLabels;
									const boolLabels2 = rowItem.line2.boolLabels;
									const colorLabel1 = rowItem.line1.colorLabel;
									const colorLabel2 = rowItem.line2.colorLabel;
									const { translate } = rowItem;
									const keyArray1 = key1.split(",");
									const keyArray2 = key2.split(",");
									let endDateValue1 = null;
									let endDateValue2 = null;
									if (endDate1) {
										endDateValue1 = getData(endDate1, rowData);
									}
									if (endDate2) {
										endDateValue2 = getData(endDate2, rowData);
									}
									let info1 = "";
									let info2 = "";
									if (keyArray1.length === 1) {
										info1 = formatData(format1, keyValue1, endDateValue1, boolLabels1, colorLabel1, translate);
									} else {
										const arrayData = getData(keyArray1[0], rowData);
										info1 = map(arrayData, (arrayItem) => {
											const keyValues = getData(keyArray1[1], arrayItem);
											const info = formatData(format1, keyValues, endDateValue1, boolLabels1, colorLabel1, translate);
											return (
												<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell} key={rowItemIndex + index}>
													{info}
													{rowItem.icon && renderIcon(rowItem.icon, rowData)}
												</div>
											);
										});
									}
									if (keyArray2.length === 1) {
										info2 = formatData(format2, keyValue2, endDateValue2, boolLabels2, colorLabel2, translate);
									} else {
										const arrayData = getData(keyArray2[0], rowData);
										info2 = map(arrayData, (arrayItem, index) => {
											const keyValues = getData(keyArray2[1], arrayItem);
											const info = formatData(format2, keyValues, endDateValue2, boolLabels2, colorLabel2, translate);
											return (
												<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell} key={rowItemIndex + index}>
													{info}
													{rowItem.icon && renderIcon(rowItem.icon, rowData)}
												</div>
											);
										});
									}
									if (get(rowItem, "canPrint", true)) {
										return (
											<Table.Cell
												onClick={() => {
													return handlerClick(rowData);
												}}
												textAlign={rowItem.dataPosition || "left"}
												verticalAlign="middle"
												key={rowItemIndex}
												className={styles.cell}>
												<div>
													{info1}
													{rowItem.line1.icon && renderIcon(rowItem.line1.icon, rowData)}
												</div>
												<div>
													{info2}
													{rowItem.icon && renderIcon(rowItem.icon, rowData)}
												</div>
											</Table.Cell>
										);
									}
								} else {
									const { key } = rowItem;
									const { onKeyEndDate } = rowItem;
									const { onClick } = rowItem;
									let { format } = rowItem;
									const keyValue = getData(key, rowData);
									const { endDate } = rowItem;
									const { boolLabels } = rowItem;
									const { colorLabel } = rowItem;
									const { translate } = rowItem;
									const keyArray = key.split(",");
									const { stringLength } = rowItem;
									const { disabled } = rowItem;

									let info;
									let endDateValue = rowItem.endDate;
									if (format === "input") format = "string";
									if (endDate && typeof endDate === "string") {
										endDateValue = getData(endDate, rowData);
									}
									if (keyArray.length === 1) {
										if (typeof keyValue === "object" && format !== "count") {
											if (format === "arrayTruncate") {
												info = truncateArray("keyValue", 1);
											} else {
												info = map(keyValue, (item, keyValueIndex) => {
													if (format === "array") {
														if (keyValue.length - 1 === keyValueIndex) {
															return ` ${item}`;
														}
														return ` ${item},`;
													}
													return (
														<div
															style={{ alignItems: rowItem.dataPosition }}
															className={styles.arrayCell}
															key={index + rowItemIndex + keyValueIndex}>
															{formatData(
																format,
																item,
																endDateValue,
																boolLabels,
																colorLabel,
																translate,
																onClick,
																rowData,
																onKeyEndDate,
																stringLength,
																disabled
															)}
														</div>
													);
												});
											}
										} else {
											info = formatData(
												format,
												keyValue,
												endDateValue,
												boolLabels,
												colorLabel,
												translate,
												onClick,
												rowData,
												onKeyEndDate,
												stringLength,
												disabled
											);
										}

										return (
											<Table.Cell
												onClick={() => {
													return handlerClick(rowData);
												}}
												textAlign={rowItem.dataPosition || "left"}
												verticalAlign="middle"
												key={index + rowItemIndex}
												className={styles.cell}>
												{info}
												{rowItem.icon && renderIcon(rowItem.icon, rowData)}
											</Table.Cell>
										);
									}
									const arrayData = getData(keyArray[0], rowData);
									const ArrayItems = map(arrayData, (arrayItem, Index) => {
										const keyValues = getData(keyArray[1], arrayItem);
										if (format === "array" || format === "arrayTruncate") {
											if (arrayData.length - 1 === Index) {
												return ` ${keyValues}`;
											}
											return ` ${keyValues},`;
										}
										const info = formatData(
											format,
											keyValues,
											endDateValue,
											boolLabels,
											colorLabel,
											translate,
											onClick,
											arrayItem,
											onKeyEndDate,
											stringLength,
											disabled
										);
										return (
											<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell} key={index + rowItemIndex + Index}>
												{info}
												{rowItem.icon && renderIcon(rowItem.icon, rowData)}
											</div>
										);
									});
									return (
										<Table.Cell
											onClick={() => {
												return handlerClick(rowData);
											}}
											textAlign={rowItem.dataPosition || "left"}
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											{ArrayItems}
											{rowItem.icon && renderIcon(rowItem.icon, rowData)}
										</Table.Cell>
									);
								}
							} else {
								return null;
							}
						} else {
							return null;
						}
					})}
				</Table.Row>
			);
		});
		if (columnSum) {
			const sumMap = sumColumn(true);
			const value = [...rowTable, sumMap];
			return <Table.Body>{value}</Table.Body>;
		}
		return <Table.Body>{rowTable}</Table.Body>;
	};

	const renderHeader = () => {
		return (
			<Table.Header className={styles.headerTable}>
				<Table.Row>
					{columns.map((item, index) => {
						if (!item.hidden) {
							if (!includes(hiddenColumns, item)) {
								let sorted = false;
								let sortKey = "";
								if (get(item, "sortKey", null)) {
									sortKey = item.sortKey;
									sorted = sortedColumnKey === sortKey;
								} else if (item.twoLines) {
									sortKey = item.line1.key;
									sorted = sortedColumnKey === sortKey;
								} else {
									sortKey = item.key;
									sorted = sortedColumnKey === sortKey;
								}
								if (item.multiple) {
									return (
										<Table.HeaderCell width={1} textAlign="center" className={styles.tableCellHeader} key={index}>
											<Checkbox
												checked={fieldEqual(concatValue, searchedData) /* isEqual(concatValue.length, dataField.length) */}
												onClick={() => {
													if (!item.disabled) {
														checkBoxValue();
													}
												}}
												disabled={item.disabled}
											/>
										</Table.HeaderCell>
									);
								}
								if (item.addButton) {
									return (
										<Table.HeaderCell width={1} textAlign="center" className={styles.tableCellHeader} key={index}>
											<Button
												icon
												/*  labelPosition="left" */
												className={styles.ButtonIconHeader}
												size="tiny"
												onClick={() => {
													onHandlerTable("Add", null);
												}}>
												<Icon name="plus" />
												{/* {"Agregar"} */}
											</Button>
											{/*  <Button
                        key={index + optionsIndex}
                        className={styles.ButtonIcon}
                        style={{ backgroundColor: options.color }}
                        onClick={() => onHandlerTable(options.onClick, rowData)}>
                        <Icon name={options.content} />
                      </Button> */}
										</Table.HeaderCell>
									);
								}
								if (item.twoLines) {
									return (
										<React.Fragment key={index}>
											{/* 	<Ref innerRef={headerRefs[index]}> */}
											<Table.HeaderCell
												ref={headerRefs[index]}
												className={styles.tableCellHeader}
												textAlign={item.headerPosition || "center"}
												width={item.width || 1}
												sorted={sorted ? sortDirection : null}
												onContextMenu={(e) => {
													return handleContextMenu(e, index);
												}}
												onClick={
													get(item, "canSort", true)
														? () => {
																return handleSort(sortKey);
														  }
														: null
												}>
												<div>{item.line1.label}</div>
												<div> {item.line2.label} </div>
											</Table.HeaderCell>
											{/* 		</Ref> */}
											<Popup
												context={headerRefs[index]}
												open={openHeaderOptions[index]}
												onClose={() => {
													return handleCloseHeaderOptions();
												}}
												position="bottom left">
												<Menu className={styles.headerMenu} secondary vertical>
													<Menu.Item
														className={styles.headerMenuItem}
														key="hide"
														content="Ocultar"
														icon="eye"
														onClick={(e) => {
															return hideData(e, item);
														}}
													/>
												</Menu>
											</Popup>
										</React.Fragment>
									);
								}
								if (item.action) {
									return (
										<Table.HeaderCell
											key={index}
											className={styles.tableCellHeader}
											textAlign={item.headerPosition || "center"}
											width={item.width || 1}
											sorted={sorted ? sortDirection : null}
											onContextMenu={(e) => {
												return handleContextMenu(e, index);
											}}>
											{item.label}
										</Table.HeaderCell>
									);
								}
								return (
									<React.Fragment key={index}>
										{/* 		<Ref innerRef={headerRefs[index]}> */}
										<Table.HeaderCell
											ref={headerRefs[index]}
											className={styles.tableCellHeader}
											textAlign={item.headerPosition || "center"}
											width={item.width || 1}
											sorted={sorted ? sortDirection : null}
											onContextMenu={(e) => {
												return handleContextMenu(e, index);
											}}
											onClick={
												get(item, "canSort", true)
													? () => {
															return handleSort(sortKey);
													  }
													: null
											}>
											{item.label}
										</Table.HeaderCell>
										{/* 		</Ref> */}
										<Popup
											context={headerRefs[index]}
											open={openHeaderOptions[index]}
											onClose={() => {
												return handleCloseHeaderOptions();
											}}
											position="bottom left">
											<Menu className={styles.headerMenu} secondary vertical>
												<Menu.Item
													className={styles.headerMenuItem}
													key="hide"
													content="Ocultar"
													icon="eye"
													onClick={(e) => {
														return hideData(e, item);
													}}
												/>
											</Menu>
										</Popup>
									</React.Fragment>
								);
							}
							return (
								<Table.HeaderCell
									textAlign="center"
									key={index}
									width={item.width || 1}
									className={styles.tableCellHeader}
									style={{ width: "1.5rem", maxWidth: "1.5rem", minWidth: "1.5rem" }}>
									<Icon
										className={styles.iconTable}
										size="large"
										onClick={(e) => {
											return hideData(e, item, "inactive");
										}}
										name="eye slash outline"
									/>
								</Table.HeaderCell>
							);
						}
						return null;
					})}
				</Table.Row>
			</Table.Header>
		);
	};

	const tableRow = () => {
		const data = filteredData;
		const rowTable = map(data, (rowData, index) => {
			let concatCliked;
			if (keyField) {
				concatCliked = find(concatValue, { fieldId: rowData.fieldId });
			} else {
				concatCliked = includes(concatValue, rowData);
			}
			return (
				<Table.Row
					key={index}
					className={clikedData === rowData || concatCliked ? styles.ColorActive : styles.groupHover}
					style={rowStyle(rowData) ? rowStyle(rowData) : {}}
					onDoubleClick={() => {
						onHandlerTable("Watch", rowData);
					}}>
					{map(columns, (rowItem, rowItemIndex) => {
						let negative = false;
						if (negativeRows) {
							const negativeRow = getData(negativeRows.key, rowData);
							if (negativeRow === negativeRows.bool) negative = true;
						}
						if (!rowItem.hidden) {
							/* a1 */
							if (!includes(hiddenColumns, rowItem)) {
								if (rowItem.action) {
									return (
										<Table.Cell
											negative={negative}
											textAlign={rowItem.dataPosition || "left"}
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cellButton}>
											{formatAction(rowItem, rowData, index)}
										</Table.Cell>
									);
								}
								if (rowItem.multiple) {
									if (keyField) {
										const concatField = find(concatValue, { fieldId: rowData.fieldId });
										return (
											<Table.Cell
												negative={negative}
												onClick={() => {
													if (!rowItem.disabled) {
														return handlerClick(rowData, true);
													}
												}}
												textAlign="center"
												verticalAlign="middle"
												key={index + rowItemIndex}
												className={styles.cell}>
												<Checkbox checked={concatField?.fieldId === rowData.fieldId} disabled={rowItem.disabled} />
											</Table.Cell>
										);
									}
									return (
										<Table.Cell
											negative={negative}
											onClick={() => {
												if (!rowItem.disabled) {
													return handlerClick(rowData, true);
												}
											}}
											textAlign="center"
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											<Checkbox checked={includes(concatValue, rowData)} disabled={rowItem.disabled} />
										</Table.Cell>
									);
								}
								if (rowItem.radio) {
									return (
										<Table.Cell
											negative={negative}
											onClick={() => {
												if (!rowItem.disabled) {
													return handlerRatio(rowData, rowItem.disabled);
												}
											}}
											textAlign="center"
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											<Checkbox radio checked={radioClikedData === rowData} disabled={rowItem.disabled} />
										</Table.Cell>
									);
								}
								if (rowItem.twoLines) {
									// tabla normal
									const key1 = rowItem.line1.key;
									const key2 = rowItem.line2.key;
									const format1 = rowItem.line1.format;
									const format2 = rowItem.line2.format;
									const keyValue1 = getData(key1, rowData);
									const keyValue2 = getData(key2, rowData);
									const endDate1 = rowItem.line1.endDate;
									const endDate2 = rowItem.line2.endDate;
									const boolLabels1 = rowItem.line1.boolLabels;
									const boolLabels2 = rowItem.line2.boolLabels;
									const colorLabel1 = rowItem.line1.colorLabel;
									const colorLabel2 = rowItem.line2.colorLabel;
									const { translate } = rowItem;
									const keyArray1 = key1.split(",");
									const keyArray2 = key2.split(",");
									let endDateValue1 = null;
									let endDateValue2 = null;
									if (endDate1) {
										endDateValue1 = getData(endDate1, rowData);
									}
									if (endDate2) {
										endDateValue2 = getData(endDate2, rowData);
									}
									let info1 = "";
									let info2 = "";
									if (keyArray1.length === 1) {
										info1 = formatData(format1, keyValue1, endDateValue1, boolLabels1, colorLabel1, translate);
									} else {
										const arrayData = getData(keyArray1[0], rowData);
										info1 = map(arrayData, (arrayItem) => {
											const keyValues = getData(keyArray1[1], arrayItem);
											let info;
											if (rowItem.line1.render) {
												info = rowItem.line1.render(arrayItem);
											} else {
												info = formatData(format1, keyValues, endDateValue1, boolLabels1, colorLabel1, translate);
											}
											return (
												<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell}>
													{info}
													{rowItem.icon && renderIcon(rowItem.icon, rowData)}
												</div>
											);
										});
									}
									if (keyArray2.length === 1) {
										info2 = formatData(format2, keyValue2, endDateValue2, boolLabels2, colorLabel2, translate);
									} else {
										const arrayData = getData(keyArray2[0], rowData);
										info2 = map(arrayData, (arrayItem) => {
											const keyValues = getData(keyArray2[1], arrayItem);
											const info = formatData(format2, keyValues, endDateValue2, boolLabels2, colorLabel2, translate);
											return (
												<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell}>
													{info}
													{rowItem.icon && renderIcon(rowItem.icon, rowData)}
												</div>
											);
										});
									}
									return (
										<Table.Cell
											negative={negative}
											onClick={() => {
												return handlerClick(rowData);
											}}
											textAlign={rowItem.dataPosition || "left"}
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											<div>
												{info1}
												{rowItem.line1.icon && renderIcon(rowItem.line1.icon, rowData)}
											</div>
											<div>
												{info2}
												{rowItem.icon && renderIcon(rowItem.icon, rowData)}
											</div>
										</Table.Cell>
									);
								}
								const { key } = rowItem;
								const { onKeyEndDate } = rowItem;
								const { onClick } = rowItem;
								const { format } = rowItem;
								const keyValue = getData(key, rowData);
								const { endDate } = rowItem;
								const { boolLabels } = rowItem;
								const { colorLabel } = rowItem;
								const { translate } = rowItem;
								const keyArray = key.split(",");
								const { stringLength } = rowItem;
								const { disabled } = rowItem;

								let info;
								let endDateValue = rowItem.endDate;
								if (endDate && typeof endDate === "string") {
									endDateValue = getData(endDate, rowData);
								}

								if (keyArray.length === 1) {
									if (rowItem.render) {
										const info = rowItem.render(rowData);
										return (
											<Table.Cell
												negative={negative}
												onClick={() => {
													return handlerClick(rowData);
												}}
												textAlign={rowItem.dataPosition || "left"}
												verticalAlign="middle"
												key={index + rowItemIndex}
												className={styles.cell}>
												{info}
												{rowItem.icon && renderIcon(rowItem.icon, rowData)}
											</Table.Cell>
										);
									}
									if (typeof keyValue === "object" && format !== "count") {
										if (format === "arrayTruncate") {
											info = truncateArray(keyValue, 1);
										} else {
											info = map(keyValue, (item, keyValueIndex) => {
												if (format === "array") {
													if (keyValue.length - 1 === keyValueIndex) {
														return ` ${item}`;
													}
													return ` ${item},`;
												}
												return (
													<div
														style={{ alignItems: rowItem.dataPosition }}
														className={styles.arrayCell}
														key={index + rowItemIndex + keyValueIndex}>
														{formatData(
															format,
															item,
															endDateValue,
															boolLabels,
															colorLabel,
															translate,
															onClick,
															rowData,
															onKeyEndDate,
															stringLength,
															disabled
														)}
													</div>
												);
											});
										}
									} else {
										info = formatData(
											format,
											keyValue,
											endDateValue,
											boolLabels,
											colorLabel,
											translate,
											onClick,
											rowData,
											onKeyEndDate,
											stringLength,
											disabled
										);
									}

									return (
										<Table.Cell
											negative={negative}
											onClick={() => {
												return handlerClick(rowData);
											}}
											textAlign={rowItem.dataPosition || "left"}
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											{info}
											{rowItem.icon && renderIcon(rowItem.icon, rowData)}
										</Table.Cell>
									);
								} else {
									let info;
									if (rowItem.render) {
										info = rowItem.render(rowData);
									}
									const arrayData = getData(keyArray[0], rowData);

									let ArrayItems = map(arrayData, (arrayItem, Index) => {
										const keyValues = getData(keyArray[1], arrayItem);

										let info;
										if (rowItem.render) {
											info = rowItem.render(arrayItem);
										} else {
											info = formatData(
												format,
												keyValues,
												endDateValue,
												boolLabels,
												colorLabel,
												translate,
												onClick,
												arrayItem,
												onKeyEndDate,
												stringLength,
												disabled
											);
										}

										return (
											<div style={{ alignItems: rowItem.dataPosition }} className={styles.arrayCell} key={index + rowItemIndex + Index}>
												{info}
												{rowItem.icon && renderIcon(rowItem.icon, rowData)}
											</div>
										);
									});
									if (format === "arrayTruncate") {
										ArrayItems = truncateArray(ArrayItems, 1, true);
									}
									return (
										<Table.Cell
											negative={negative}
											onClick={() => {
												return handlerClick(rowData);
											}}
											textAlign={rowItem.dataPosition || "left"}
											verticalAlign="middle"
											key={index + rowItemIndex}
											className={styles.cell}>
											{info || ArrayItems}
											{rowItem.icon && renderIcon(rowItem.icon, rowData)}
										</Table.Cell>
									);
								}
							}
							return (
								<Table.Cell
									negative={negative}
									onClick={() => {
										return handlerClick(rowData);
									}}
									textAlign={rowItem.dataPosition || "left"}
									verticalAlign="middle"
									key={index + rowItemIndex}
									className={styles.cell}
								/>
							);
						}
						return null;
					})}
				</Table.Row>
			);
		});

		if (columnSum) {
			const sumMap = sumColumn();
			return [...rowTable, sumMap];
		}
		return [...rowTable];
	};

	const sumColumn = (pdf) => {
		let column = columns;
		if (data) {
			if (pdf) {
				column = reject(columns, { label: "Acciones" });
			}
			column = reject(columns, { hidden: true });

			const sumMap = map(column, (item, index) => {
				if (item.sum) {
					let sum = 0;
					for (const row of data) {
						if (getData(item.key, row, 0) !== null) {
							sum += parseInt(getData(item.key, row, 0));
						} else {
							sum += getData(item.key, row);
						}
					}
					if (sum === parseInt(sum, 10)) {
						let num = sum;
						if (item.format === "currency") num = currencyFormat(sum);
						return (
							<Table.Cell textAlign="center" verticalAlign="middle" key={index} className={styles.sumCell}>
								{num}
							</Table.Cell>
						);
					}
					const num = currencyFormat(sum);
					return (
						<Table.Cell textAlign="center" verticalAlign="middle" key={index} className={styles.sumCell}>
							{num}
						</Table.Cell>
					);
				}
				return <Table.Cell textAlign="center" verticalAlign="middle" key={index} className={styles.sumCell} />;
			});
			return sumMap;
		}
	};

	const renderData = () => {
		const data = filteredData;
		if (isEmpty(data)) {
			const ListTableEmpty = (
				<Table.Body>
					<Table.Row>
						<Table.Cell colSpan={columns.length}>
							<div className={styles.emptyChat}>
								<Header as="h3" color="grey">
									<div className={styles.emptyDataIcon}>
										<Icon.Group size="large">
											<Icon name="list alternate outline" className={styles.IconDataBase} />
											<Icon corner name="close" color="red" />
										</Icon.Group>
									</div>
									No se ha encontrado ningun dato
								</Header>
							</div>
						</Table.Cell>
					</Table.Row>
				</Table.Body>
			);
			return ListTableEmpty;
		}
		return <Table.Body>{tableRow()}</Table.Body>;
	};

	const renderFooter = () => {
		const itemRange = (activePage - 1) * pageRows;
		return (
			<Table.Footer className={styles.headerFooter}>
				<Table.Row>
					<Table.HeaderCell colSpan="16" className={styles.paginationCell}>
						<div className={styles.content}>
							<div className={styles.paginationContainer}>
								<Pagination
									className={styles.pagination}
									activePage={activePage}
									ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
									firstItem={{ content: <Icon name="angle double left" />, icon: true }}
									lastItem={{ content: <Icon name="angle double right" />, icon: true }}
									prevItem={{ content: <Icon name="angle left" />, icon: true }}
									nextItem={{ content: <Icon name="angle right" />, icon: true }}
									totalPages={String(totalPages)}
									onPageChange={onPageChanged}
								/>
								{searchedData.length >= 1 && renderItemCount(itemRange, filteredData.length, searchedData.length)}
							</div>
							{showRowSelector && (
								<div className={styles.rowSelectorContainer}>
									<span className={styles.span}>Filas:</span>
									<span>{pageRows}</span>
								</div>
							)}
						</div>
					</Table.HeaderCell>
				</Table.Row>
			</Table.Footer>
		);
	};

	const renderFooterPrint = () => {
		return (
			<Table.Footer className={styles.headerFooter}>
				<Table.Row>
					<Table.HeaderCell colSpan="16" className={styles.paginationCell}>
						<div className={styles.pagination}>
							<Text className={styles.itemCount}>Elementos: {searchedData.length}</Text>
						</div>
					</Table.HeaderCell>
				</Table.Row>
			</Table.Footer>
		);
	};

	const renderMobileAddButton = () => {
		if (!mobileCardView || !mobileAddButton) return null;

		return (
			<div className={styles.mobileAddButtonContainer}>
				<button
					type="button"
					className={styles.addButtonMobile}
					onClick={() => {
						return onHandlerTable("Add", null);
					}}>
					<Icon name="plus" />
					Agregar
				</button>
			</div>
		);
	};

	const renderMobileCards = () => {
		const dataToRender = mobileCardData || filteredData;

		if (!mobileCardView) {
			return null;
		}

		if (isEmpty(dataToRender)) {
			return (
				<div className={styles.emptyStateCard}>
					<Header as="h3" color="grey">
						<div className={styles.emptyIconCard}>
							<Icon.Group size="large">
								<Icon name="list alternate outline" />
								<Icon corner name="close" color="red" />
							</Icon.Group>
						</div>
						No se ha encontrado ningún dato
					</Header>
				</div>
			);
		}

		const multipleColumn = find(columns, { multiple: true });

		return map(dataToRender, (rowData, index) => {
			const renderCardLine = (lineConfig, lineIndex) => {
				if (!lineConfig || isEmpty(lineConfig)) {
					return null;
				}

				const validItems = filter(lineConfig, (item) => {
					const keyValue = getData(item.key, rowData);

					const isIdField = item.key === "id" || item.label === "ID" || (item.key && item.key.toLowerCase().includes("id"));

					// Siempre mostramos ID e inputHour aunque estén vacíos
					if (isIdField || item.format === "inputHour") {
						return true;
					}

					const endDateValue = item.endDate && typeof item.endDate === "string" ? getData(item.endDate, rowData) : item.endDate || null;

					const formattedValue = item.format
						? formatData(
								item.format,
								keyValue,
								endDateValue,
								item.boolLabels,
								item.colorLabel,
								item.translate,
								item.onClick,
								rowData,
								item.onKeyEndDate,
								item.stringLength,
								item.disabled
						  )
						: keyValue;

					return formattedValue !== null && formattedValue !== undefined && formattedValue !== "";
				});

				if (isEmpty(validItems)) {
					return null;
				}

				return (
					<div key={lineIndex} className={lineIndex === 0 ? styles.mobileCardLineFirst : styles.mobileCardLineSecond}>
						{map(validItems, (item, itemIndex) => {
							const keyValue = getData(item.key, rowData);

							const isIdField = item.key === "id" || item.label === "ID" || (item.key && item.key.toLowerCase().includes("id"));

							const endDateValue = item.endDate && typeof item.endDate === "string" ? getData(item.endDate, rowData) : item.endDate || null;

							// Para inputHour (y cualquier otro formato) usamos siempre formatData,
							// así en mobile también se renderiza el <Input type="time" />.
							const formattedValue = item.format
								? formatData(
										item.format,
										keyValue,
										endDateValue,
										item.boolLabels,
										item.colorLabel,
										item.translate,
										item.onClick,
										rowData,
										item.onKeyEndDate,
										item.stringLength,
										item.disabled
								  )
								: keyValue;

							let displayValue;
							if (isIdField) {
								if (formattedValue === null || formattedValue === undefined || formattedValue === "") {
									displayValue = "-";
								} else if (formattedValue === 0 || formattedValue === "0") {
									displayValue = "0";
								} else {
									displayValue = formattedValue;
								}
							} else {
								displayValue = formattedValue || "-";
							}

							return (
								<div key={itemIndex} className={styles.mobileCardItem}>
									{item.label && <span className={styles.mobileCardLabel}>{item.label}</span>}
									<span className={styles.mobileCardValue}>
										<div className={styles.mobileInputWrapper}>{displayValue}</div>
									</span>
								</div>
							);
						})}
					</div>
				);
			};

			const isChecked = multipleColumn
				? keyField
					? find(concatValue, { fieldId: rowData.fieldId })?.fieldId === rowData.fieldId
					: includes(concatValue, rowData)
				: false;

			return (
				<div
					key={index}
					className={`${styles.mobileCard} ${multipleColumn ? styles.hasCheckbox : ""}`}
					onClick={() => {
						if (multipleColumn) {
							return handlerClick(rowData, true);
						}
						return handlerClick(rowData);
					}}
					onDoubleClick={() => {
						return onHandlerTable("Watch", rowData);
					}}>
					{multipleColumn && (
						<div
							className={styles.mobileCardCheckbox}
							onClick={(e) => {
								e.stopPropagation();
								return handlerClick(rowData, true);
							}}>
							<Checkbox checked={isChecked} disabled={multipleColumn.disabled} />
						</div>
					)}
					{renderCardLine(cardLine1, 0)}
					{renderCardLine(cardLine2, 1)}
					{renderCardLine(cardLine3, 2)}
				</div>
			);
		});
	};

	const handlePrint = useReactToPrint({
		content: () => {
			return componentRef.current;
		},
	});

	const excelKeyMaker = (value) => {
		if (value) {
			return value.split(".").join("");
		}
	};

	const exelData = () => {
		let dataExel = [];
		let columnExel = [];
		let column = [];
		for (const columnItem of columns) {
			if (!columnItem.hidden) {
				if (!includes(hiddenColumns, columnItem)) {
					if (columnItem.twoLines) {
						const item1 = columnItem.line1;
						const item2 = columnItem.line2;
						column = [...column, item1, item2];
					} else {
						column = [...column, columnItem];
					}
				}
			}
		}
		for (const dataItem of data) {
			let rowExel = {};
			for (const columnItem of column) {
				if (columnItem.key && get(columnItem, "canExcel", true)) {
					let endDateValue = columnItem.endDate;
					if (endDateValue && typeof endDateValue === "string") {
						endDateValue = getData(endDateValue, dataItem);
					}
					let value = "";
					const name = excelKeyMaker(columnItem.key);
					const keyArray = columnItem.key.split(",");
					if (keyArray.length === 1) {
						value = getData(columnItem.key, dataItem);
						value = formatPrintData(
							columnItem.format,
							value,
							dataItem,
							endDateValue,
							columnItem.onKeyEndDate,
							columnItem.translate,
							columnItem.boolLabels
						);
						rowExel = { ...rowExel, [name]: value };
					} else {
						const arrayData = getData(keyArray[0], dataItem);
						for (const item of arrayData) {
							if (value === "") {
								value = getData(keyArray[1], item);
								value = formatPrintData(
									columnItem.format,
									value,
									item,
									endDateValue,
									columnItem.onKeyEndDate,
									columnItem.translate,
									columnItem.boolLabels
								);
								if (value === null || value === undefined || value === "") {
									value = "null";
								}
							} else {
								let newData = getData(keyArray[1], item);
								newData = formatPrintData(
									columnItem.format,
									newData,
									item,
									endDateValue,
									columnItem.onKeyEndDate,
									columnItem.translate,
									columnItem.boolLabels
								);
								if (newData === null || newData === undefined || newData === "") {
									newData = "null";
								}
								value = `${value}, ${newData}`;
							}
						}
						rowExel = { ...rowExel, [name]: value };
					}
				}
			}
			dataExel = [...dataExel, rowExel];
		}

		for (const columnItem of column) {
			if (columnItem.key && get(columnItem, "canExcel", true)) {
				columnExel = [...columnExel, columnItem];
			}
		}
		columnExel = map(columnExel, (item) => {
			return { label: item.label, key: excelKeyMaker(item.key) };
		});
		setFormatExelData(dataExel);
		setColumnsExel(columnExel);
	};

	/* const renderExelFile = () => {
		return null; */
	// <ExcelFile filename={printHeader.title} element={<Button className={styles.exelButton} color="green" icon={"file excel"} />}>
	//   <ExcelSheet data={formatExelData} name={printHeader.title}>
	//     {map(columnsExel, (rowItem, index) => {
	//       const key = excelKeyMaker(rowItem.key);
	//       return <ExcelColumn label={rowItem.label} value={key} key={index} />;
	//     })}
	//   </ExcelSheet>
	// </ExcelFile>
	/* }; */

	return (
		<div>
			<div className={styles.rowMiddle}>
				{searchable && (
					<div className={/* topCustomButtons ||  */ styles.searchContainer} style={{ justifyContent: searchPosition }}>
						<div className={styles.filterContainer}>
							<Input
								name="searchString"
								disabled={searchDisable}
								onChange={handleInput}
								placeholder="Buscar"
								value={searchQuery}
								dropdownPosition={searchDropdownPosition}
								dropdown={{
									disabled: searchDisable,
									options: searchOptions,
									name: "searchField",
									onChange: handleDropdown,
									value: searchField,
								}}
							/>
						</div>
					</div>
				)}
				{topCustomButtons && hiddenTopCustomButtons && <div className={styles.customButtonContainer}>{topCustomButtons}</div>}

				<div className={styles.addPrintButtonContainer}>
					{addButton && (
						<Button
							icon
							labelPosition="left"
							className={styles.addButton}
							size="medium"
							onClick={() => {
								onHandlerTable("Add", null);
							}}>
							<Icon name="plus" />
							{addButton}
						</Button>
					)}
					{printable && (
						<div className={styles.printableButtons}>
							<Button onClick={handlePrint} className={styles.printButton} primary icon="print" />
							{/* {renderExelFile()} */}
							<CSVLink data={formatExelData} headers={columnsExel} filename={printHeader.title} target="_blank">
								<Button className={styles.exelButton} color="green" icon="file excel" />
							</CSVLink>

							{/* <Button
                className={styles.exelButton}
                color="green"
                icon={"file excel"}
                onClick={() => {
                  return <CSVDownload data={csvData} />;
                }}
              /> */}
						</div>
					)}
				</div>
			</div>
			{mobileCardView && (
				<div className={styles.cardsContainerMobile}>
					{renderMobileAddButton()}
					{renderMobileCards()}
				</div>
			)}

			<div className={styles.mainContainer}>
				<Table sortable celled striped>
					{renderHeader()}
					{renderData()}
					{haveFooter && renderFooter()}
				</Table>
			</div>
			<div className={styles.rowMiddle}>
				{(bottomCustomButtons || multiplePosition) && (
					<div className={styles.multipleActions} style={{ justifyContent: multiplePosition }}>
						{/* <Button className={styles.positiveDesButton} disabled={isEmpty(concatValue)} onClick={() => setConcatValue([])}>
              {"Desmarcar Todos"}
            </Button> */}
						<div className={styles.bottomCustomButtonContainer}>{bottomCustomButtons}</div>
						{multiplePosition && (
							<Button
								className={styles.positiveAddButton}
								disabled={isEmpty(concatValue)}
								onClick={() => {
									return handlerTable("multiple", concatValue);
								}}>
								Agregar
							</Button>
						)}
					</div>
				)}
			</div>
			{printable && (
				<div style={{ display: "none" }}>
					<div ref={componentRef}>
						<NewTablePrint header={headerPrint} body={tableRowPrint} footer={renderFooterPrint} printHeader={printHeader} />
					</div>
				</div>
			)}
		</div>
	);
};

NewTable.propTypes = {
	onChange: PropTypes.func,
	columns: PropTypes.array,
	defaultOrder: PropTypes.object,
	pageRows: PropTypes.number,
	data: PropTypes.array,
};

// Styles

export default NewTable;
